import { render, staticRenderFns } from "./ProofReceiptImageView.vue?vue&type=template&id=47f3fd0a&scoped=true"
import script from "./ProofReceiptImageView.vue?vue&type=script&lang=js"
export * from "./ProofReceiptImageView.vue?vue&type=script&lang=js"
import style0 from "./ProofReceiptImageView.vue?vue&type=style&index=0&id=47f3fd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f3fd0a",
  null
  
)

export default component.exports